import {createFileRoute, redirect} from '@tanstack/react-router';

import {Route as RouteEnum, SettingsSearchParams} from '~utils/routeUtil';

export const Route = createFileRoute('/settings/devices')({
  validateSearch: SettingsSearchParams.validate,
  beforeLoad: async () => {
    // Redirect to shifts settings (devices page appears to be deprecated/disabled)
    throw redirect({
      to: RouteEnum.settingsShifts as any,
    });
  },
});
